import { ETA_PLACEHOLDER, ETA_TEMPLATE_ERROR_KINDS, OLD_MAIL_PLACEHOLDER_REGEX } from 'cpool-constants';
import type { ETA_PLACEHOLDER_TYPE } from 'cpool-constants';
import { Eta } from 'eta/core';

import type { ValueOf } from './typeUtils.js';

export type EtaTemplateError =
    | { kind: typeof ETA_TEMPLATE_ERROR_KINDS.LEGACY_PLACEHOLDER; placeholder: string }
    | { kind: typeof ETA_TEMPLATE_ERROR_KINDS.SYNTAX; message: string };

const eta = new Eta({ autoEscape: false, autoTrim: false });

export const findEtaTemplateError = (
    template: string,
    allowedPlaceholders: Readonly<Array<ValueOf<ETA_PLACEHOLDER_TYPE>>>,
): EtaTemplateError | undefined => {
    const legacyPlaceholderMatch = template.match(OLD_MAIL_PLACEHOLDER_REGEX);
    if (legacyPlaceholderMatch) {
        return { kind: ETA_TEMPLATE_ERROR_KINDS.LEGACY_PLACEHOLDER, placeholder: legacyPlaceholderMatch[0] };
    }

    const etaContext = Object.fromEntries(
        allowedPlaceholders.map((placeholder) => [
            placeholder,
            placeholder === ETA_PLACEHOLDER.FREITEXT ? () => '' : '',
        ]),
    );
    try {
        eta.renderString(template, etaContext);
    } catch (error) {
        return { kind: ETA_TEMPLATE_ERROR_KINDS.SYNTAX, message: (error as Error).message.split('\n')[0] ?? '' };
    }
    return undefined;
};
